module.exports = __webpack_public_path__ + "assets/img/定制性更丰富.ae546f16.jpg";